import { useContext, useState, useEffect, React } from 'react';
import { Link } from "react-router-dom";
import { Button, Form, Label, Input, FormGroup, FormText } from 'reactstrap';
import { CartContext } from '../context/CartContext';
//import { addDoc, collection, serverTimestamp } from 'firebase/firestore'
import { toast } from "react-toastify";
//import volver from "../../assets/volver.png";
import { useForm } from 'react-hook-form';

const CheckOut = () => {

    const { cart, precioTotal, clear, removeItem } = useContext(CartContext)
    const [cuantoAbona, setCuantoAbona] = useState(true);
const precioYenvio = precioTotal + 100;
    console.log(precioTotal)

    const abonaEfectivo = () => {
        setCuantoAbona(!cuantoAbona)
    }

    const {
        register,
        handleSubmit,
        formState: { errors },
    } = useForm();
    const onSubmit = (data) => {

        let msj = `*Hola Sandwhiches Roma!! Quiero hacer un pedido!*%0A%0A
*Productos*%0A

  ${cart.map((item) => item.cantidad + "X de " + item.producto.nombre + " | $" + item.producto.precio + "%0A")}
  %0A
*Entrega*%0A
  • Método de Entrega: Envio%0A
  • Direccion: ${data.calleAltura}%0A
  • Recibe: ${data.nombreCliente}%0A

*Pago*%0A
  • Método de Pago: ${data.abono}%0A
  ${data.abono === "Efectivo" ? `• Abona con: $${data.abonaCon}%0A` : "%0A"}

  • Subtotal del Pedido: $${precioTotal}%0A
  • Costo envio: $ 100%0A
  • Total del Pedido: $${precioTotal + 100}%0A
        `;
        console.log(msj)
        toast.success("Tu pedido se ha enviado correctamente!");
        //setMensaje(`https://wa.me/5491140449043?text=${msj.replaceAll(",", "  ")}`)
        //let url = `https://wa.me/5491140449043?text=${msj.replaceAll(",", "  ")}`;
        window.open(`https://wa.me/5491137807560?text=${msj.replaceAll(",", "  ")}`);
        clear();

        //  window.location.href = mensaje;
        //window.location.href = (`https://wa.me/5491140449043?text=${msj.replaceAll(",", "  ")}`);
        //window.location.replace(`https://wa.me/5491140449043?text=${msj.replaceAll(",", "  ")}`);
    };

    console.log(errors.abonaCon)
    return (
        <form className='checkout-form' onSubmit={handleSubmit(onSubmit)}>
            <h2 style={{
                paddingBottom: "20px",
                fontSize: "25px",
                fontWeight: "550"
            }}>Informacion de Envio</h2>



            <div className="form__group">
                <input
                    id='nombreCliente'
                    type="text"
                    className="form__field w-100"
                    placeholder="Nombre del cliente"
                    {...register('nombreCliente', { required: true })}
                />
                <label htmlFor="nombreCliente" className="form__label"> Nombre </label>
                {errors.nombreCliente && <p className='error-alert'>Completa este campo.</p>}
            </div>
            <div className="form__group">
                <input
                    id='calleAltura'
                    type="text"
                    className="form__field"
                    placeholder="Calle y altura"
                    {...register('calleAltura', { required: true })}
                />
                <label htmlFor="calleAltura" className="form__label"> Calle y altura </label>
                {errors.calleAltura && <p className='error-alert'>Completa este campo.</p>}
            </div>
            <div className="form__group">
                <input
                    id='entreCalles'
                    type="text"
                    className="form__field"
                    placeholder="Input text"
                    {...register('entreCalles', { required: true })}
                />
                <label htmlFor="entreCalles" className="form__label"> Entre Calles </label>
                {errors.entreCalles && <p className='error-alert'>Completa este campo.</p>}
            </div>

            <div>
                <h2 style={{
                    paddingBottom: "20px",
                    fontSize: "25px",
                    fontWeight: "550"
                }}>Metodo de Pago</h2>

                <div style={{
                    fontWeight: "700",
                    fontSize: "16px",
                    display: "flex",
                    justifyContent: "space-between",
                    color: "#585065"
                }}>SubTotal <span>${precioTotal}</span></div>
                <div style={{
                    fontWeight: "700",
                    fontSize: "16px",
                    display: "flex",
                    justifyContent: "space-between",
                    color: "#585065",
                    paddingBottom: "9px",
                    marginBottom: "9px",
                    borderBottom: "1px solid #1a202a49"
                }}>Envio <span>$100</span></div>
                <div style={{
                    fontWeight: "700",
                    fontSize: "18px",
                    display: "flex",
                    justifyContent: "space-between",
                }}>Total <span>${precioTotal + 100}</span></div>

                <label className="container-checkbox">
                    <input
                        type="checkbox"
                        checked={cuantoAbona}
                        value="Efectivo"
                        onClick={abonaEfectivo}
                        {...register('abono', { required: true })}
                    />
                    <div className="checkmark"></div>
                    <label className='checkbox-label'>Efectivo</label>
                </label>
                {cuantoAbona ?
                    <div className="form__group">
                        <input
                            id='abonaCon'
                            type="text"
                            className="form__field"
                            placeholder="¿Con cuanto pagas?"
                            {...register('abonaCon',
                                {
                                    required: true,
                                    validate: (value) => value >= precioYenvio
                                })}
                        />
                        <label htmlFor="abonaCon" className="form__label"> ¿Con cuanto pagas? </label>
                        {errors.abonaCon ?
                            null
                            :

                            <p style={{
                                fontWeight: "600",
                                fontSize: "14px",
                                color: "#585065",
                                marginTop: "5px"
                            }}>El monto ingresado debe ser mayor o igual a ${precioTotal + 100}</p>
                        }
                        {errors.abonaCon && errors.abonaCon.type === "required" && (
                            <p className='error-alert'>Completa este campo.</p>
                        )}
                        {errors.abonaCon && errors.abonaCon.type === "validate" && (
                            <p className='error-alert'>Debe ser igual o mayor al monto final.</p>
                        )}
                    </div>
                    :
                    null}
                <label className="container-checkbox">
                    <input
                        type="checkbox"
                        value="Mercado Pago"
                        checked={!cuantoAbona}
                        onClick={abonaEfectivo}
                        {...register('abono', { required: true })}
                    />
                    <div className="checkmark"></div>
                    <label className='checkbox-label'>Mercado Pago</label>
                </label>
            </div>
            <div className='check-cont-btn'  >
                <button type="submit" className='carrito-btn'>Enviar pedido</button>
            </div>
        </form>


    )
}

export default CheckOut